import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ModalX from '@websky/core/src/BaseComponents/ModalX';
import { getOrder } from '@websky/core/src/Checkout/store/order/selectors';
import css from './InfoLinksLabel.css';
import { checkInternationalFlight } from '@websky/core/src/Checkout/utils';
const moscowIata = new Set(['BKA', 'VKO', 'DME', 'SVO', 'ZIA']);
const isMoscowIncludedFlight = (segment) => moscowIata.has(segment.segment.arrival.airport.iata) || moscowIata.has(segment.segment.departure.airport.iata);
export const renderCheckoutLinksLabel = companyInfo => {
    const { t, i18n } = useTranslation();
    const order = useSelector(getOrder);
    const [isPassportControlModalOpen, setIsPassportControlModalOpen] = React.useState(false);
    const onClick = (e) => {
        const target = e.target;
        if (target.hasAttribute('data-type')) {
            e.preventDefault();
            const linkType = target.getAttribute('data-type');
            if (linkType === 'passportControl') {
                setIsPassportControlModalOpen(true);
            }
        }
    };
    const customAgreement = React.useMemo(() => {
        const isInternationalFlight = checkInternationalFlight(order.flight);
        const isMoscowInternationalFlight = order.flight.segments.some(segment => isMoscowIncludedFlight(segment) && isInternationalFlight);
        if (isMoscowInternationalFlight &&
            i18n.exists('CheckoutCustomAgreement', { ns: 'Checkout', fallbackLng: i18n.language })) {
            return t('Checkout:CheckoutCustomAgreement');
        }
        return t('Checkout:CheckoutDefaultAgreement');
    }, []);
    return (React.createElement("div", { className: css.wrapper, onClick: onClick },
        React.createElement("div", { dangerouslySetInnerHTML: { __html: customAgreement } }),
        React.createElement(ModalX, { scroll: "paper", size: "xlarge", isOpen: isPassportControlModalOpen, onClose: () => setIsPassportControlModalOpen(false) },
            React.createElement("div", { className: css.title }, t('Checkout:PassportControlModal_title')),
            React.createElement("div", null, t('Checkout:PassportControlModal_text')))));
};
